// extracted by mini-css-extract-plugin
export default {"main":"Home_main__AN3z1","home":"Home_home__bfnSQ","h2":"Home_h2__TeiWp","p1":"Home_p1__otFUC","p2":"Home_p2__+M8CW","cartoon":"Home_cartoon__BNQGF"};